import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf'
import { baseUrl } from "../../../resources/Constants";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import ModalExamenes from "./ModalExamenes";
import ModalFormulas from "./ModalFormulas";
import ModalOtrosDocumentos from "./ModalOtrosDocumentos";
import ModalIncapacidades from "./ModalIncapacidades";
import ModalRecomendaciones from "./ModalRecomendaciones";
import ModalRemisiones from "./ModalRemisiones";
import ModalContraremisiones from "./ModalContraremisiones";
import ModalConsentimientos from "./ModalConsentimientos";
import ModalOdontograma from "./ModalOdontograma";
import ModalArchivosClinicos from "./ModalArchivosClinicos";
import DocumentoPacienteModal from "./DocumentoPacienteModal";

import RegistroRipsSinFev from "../rips/RegistroRipsSinFev";
import RegistroRipsFev from "../rips/RegistroRipsFev";
import RegistroRipsConvenio from "../rips/RegistroRipsConvenio";
import { Modal, Button } from "react-bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { tiposDocumento, sexoBiologico, discapacidades, etnias, identidadesGenero } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";
import {
    puedeAccederModuloClinico,
    debeFiltrarPorProfesional,
    esUsuarioAdministrativo,
    getUserData,
} from "../../../utils/userAccessHelpers";

const MESES_ES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

const formatearFechaNacimientoLegible = (fechaStr) => {
    if (!fechaStr) return 'No registrada';
    const match = String(fechaStr).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return fechaStr;
    const day = parseInt(match[3], 10);
    const month = MESES_ES[parseInt(match[2], 10) - 1];
    return `${day} de ${month} de ${match[1]}`;
};

const formatearFechaHoraIngreso = (fechaStr) => {
    if (!fechaStr) return '';
    const date = new Date(fechaStr);
    if (Number.isNaN(date.getTime())) return fechaStr;
    return date.toLocaleString('es-CO', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    });
};

/** estado en evolucion: 0=guardado, 1=borrador (paridad HC) */
const ESTADO_EVOLUCION_GUARDADA = 0;

const escapeHtmlNota = (texto) =>
    String(texto ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/\n/g, '<br />');

const formatearFechaNotaDisplay = (fecha) => {
    if (!fecha) return '';
    const s = String(fecha).replace('T', ' ');
    return s.length > 16 ? s.slice(0, 16) : s;
};

const notasDeRegistroParaPdf = (registroId, tipo, listaNotas) =>
    (listaNotas || []).filter(
        (n) => String(n.tipo) === tipo && Number(n.id_evolucion_historia) === Number(registroId)
    );

const construirSeccionesNotasAclaratoriasPdf = (registroId, tipo, listaNotas) => {
    const notas = notasDeRegistroParaPdf(registroId, tipo, listaNotas);
    if (!notas.length) return [];
    return notas.map((n, idx) => ({
        tipo: 'texto',
        titulo: notas.length > 1 ? `Nota aclaratoria (${idx + 1})` : 'Nota aclaratoria',
        contenido: `<p><strong>Fecha:</strong> ${escapeHtmlNota(formatearFechaNotaDisplay(n.fecha))}</p><p>${escapeHtmlNota(n.nota_aclaratoria)}</p>`,
        estilos: { margenSuperiorMm: 3, htmlTextoCompacto: false },
    }));
};

const cargarNotasAclaratoriasPacientePdf = async (idPaciente) => {
    if (!idPaciente) return [];
    try {
        const [rEvol, rHist] = await Promise.all([
            axios.get('/notas-aclaratorias', { params: { tipo: 'evolucion', paciente_id: idPaciente } }),
            axios.get('/notas-aclaratorias', { params: { tipo: 'historia', paciente_id: idPaciente } }),
        ]);
        return [...(rEvol.data?.notas || []), ...(rHist.data?.notas || [])];
    } catch (error) {
        console.warn('[PDF consolidado] Notas aclaratorias no disponibles:', error);
        return [];
    }
};

function AtenderPaciente2() {

    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');

    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [genero, setGenero] = useState('');
    const [tipoSangre, setTipoSangre] = useState('');
    const [estadoCivil, setEstadoCivil] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [fechaIngreso, setFechaIngreso] = useState('');
    const [religion, setReligion] = useState('');
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [ciudadNacimiento, setCiudadNacimiento] = useState('');
    const [edad, setEdad] = useState('');
    const [ocupacion, setOcupacion] = useState('');
    const [nacionalidad, setNacionalidad] = useState('');
    const [estadoPaciente, setEstadoPaciente] = useState('');
    const [direccion, setDireccion] = useState('');
    const [pais, setPais] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [paisResidencia, setPaisResidencia] = useState('');
    const [vinculacion, setVinculacion] = useState('');
    const [eps, setEps] = useState('');
    const [nombreEps, setNombreEps] = useState('');
    const [clasificacion, setClasificacion] = useState('');
    const [convenio, setConvenio] = useState('');
    const [medioPublicitario, setMedioPublicitario] = useState('');
    const [referido, setReferido] = useState('');
    const [nombreAcompanante, setNombreAcompanante] = useState('');
    const [telefonoAcompanante, setTelefonoAcompanante] = useState('');
    const [parentescoAcompanante, setParentescoAcompanante] = useState('');
    const [documentoAcompanante, setDocumentoAcompanante] = useState('');
    const [emailAcompanante, setEmailAcompanante] = useState('');
    const [nombreResponsable, setNombreResponsable] = useState('');
    const [telefonoResponsable, setTelefonoResponsable] = useState('');
    const [docResponsable, setDocResponsable] = useState('');
    const [emailResponsable, setEmailResponsable] = useState('');
    const [parentescoResponsable, setParentescoResponsable] = useState('');
    const [nombreMadre, setNombreMadre] = useState('');
    const [documentoMadre, setDocumentoMadre] = useState('');
    const [telefonoMadre, setTelefonoMadre] = useState('');
    const [ocupacionMadre, setOcupacionMadre] = useState('');
    const [nombrePadre, setNombrePadre] = useState('');
    const [documentoPadre, setDocumentoPadre] = useState('');
    const [telefonoPadre, setTelefonoPadre] = useState('');
    const [ocupacionPadre, setOcupacionPadre] = useState('');
    const [clasificacionRiesgo, setClasificacionRiesgo] = useState('');
    const [descripcionClasificacion, setDescripcionClasificacion] = useState('');
    const [etnia, setEtnia] = useState('');
    const [horaNacimiento, setHoraNacimiento] = useState('');
    const [identidadGenero, setIdentidadGenero] = useState('');
    const [discapacidad, setDiscapacidad] = useState('');
    const [profesionalAsignado, setProfesionalAsignado] = useState('');

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [aseguradoras, setAseguradoras] = useState([]);
    const [convenios, setConvenios] = useState([]);
    const [mediosPublicitarios, setMediosPublicitarios] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));
    const [idCita, setIdCita] = useState(new URLSearchParams(queryParams).get('ct'));

    const [idPaisNacimiento, setIdPaisNacimiento] = useState();
    const [idCiudadNacimiento, setIdCiudadNacimiento] = useState();
    const [idCiudad, setIdCiudad] = useState();
    const [idNacionalidad, setIdNacionalidad] = useState();
    const [idPaisResidencia, setIdPaisResidencia] = useState();

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [emailProfesional, setEmailProfesional] = useState('');
    const [especialidad, setEspecialidad] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [perfilimg, setPerfilimg] = useState('/dist/img/user-default.jpg');
    const logoImg = '/dist/img/logo-2.png';

    const [errorlist, setErrorlist] = useState({});
    const [estadosCita, setEstadosCita] = useState([]);
    const [estiloInfoMenores, setEstiloInfoMenores] = useState({});

    let history = useHistory();
    let userdata = [];

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    
    // Estados para permisos específicos
    const [tienePermisoDocumentos, setTienePermisoDocumentos] = useState(false);
    const [tienePermisoHistoriaClinica, setTienePermisoHistoriaClinica] = useState(false);
    const [tienePermisoEvolucion, setTienePermisoEvolucion] = useState(false);
    const [tienePermisoRips, setTienePermisoRips] = useState(false);
    const [tienePermisoToxina, setTienePermisoToxina] = useState(false);
    const [tienePermisoOdontograma, setTienePermisoOdontograma] = useState(false);
    const [esAdministrativo, setEsAdministrativo] = useState(false);

    // Estados para controlar acordeones
    const [acordeonInfoPaciente, setAcordeonInfoPaciente] = useState(false);
    const [acordeonAtencion, setAcordeonAtencion] = useState(false);

    const esUsuarioProfesionalIndependiente = () => debeFiltrarPorProfesional(getUserData());

    const normalizarFechaHoraParaInput = (valor) => {
        if (valor == null || valor === '') return '';
        if (valor instanceof Date) {
            const y = valor.getFullYear();
            const m = String(valor.getMonth() + 1).padStart(2, '0');
            const d = String(valor.getDate()).padStart(2, '0');
            const h = String(valor.getHours()).padStart(2, '0');
            const min = String(valor.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${d}T${h}:${min}`;
        }
        const s = String(valor).trim();
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) return s.replace(' ', 'T').slice(0, 16);
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) return s.slice(0, 16);
        const d = new Date(s);
        if (Number.isNaN(d.getTime())) return s;
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const obtenerFechaHoraVisual = (valor) => {
        const normalizada = normalizarFechaHoraParaInput(valor);
        if (!normalizada) return 'No registrada';
        const dateObj = new Date(normalizada);
        if (Number.isNaN(dateObj.getTime())) return String(valor || '');
        try {
            return dateObj.toLocaleString('es-CO', { dateStyle: 'short', timeStyle: 'short' });
        } catch (e) {
            return normalizada.replace('T', ' ');
        }
    };

    const esCadenaSoloHoraEvol = (v) => {
        if (v == null || v === '') return false;
        return /^\d{1,2}:\d{2}(:\d{2})?$/.test(String(v).trim());
    };

    const parteSoloFechaEvol = (fe) => {
        if (fe == null || fe === '') return '';
        const s = String(fe).trim();
        if (s.includes('T')) return s.split('T')[0];
        return s.split(/\s+/)[0] || '';
    };

    /** Misma lógica que ModalEvolucion: fecha día + hora TIME en columnas distintas */
    const obtenerFechaHoraVisualEvolucion = (evol) => {
        if (!evol) return 'No registrada';
        const hi = evol.hora_inicial;
        const fe = evol.fecha;
        let valor = '';
        if (hi != null && hi !== '' && esCadenaSoloHoraEvol(hi) && fe != null && fe !== '') {
            const dia = parteSoloFechaEvol(fe);
            if (dia) valor = `${dia} ${String(hi).trim()}`;
        }
        if (!valor) valor = hi || fe || '';
        return obtenerFechaHoraVisual(valor);
    };

    const construirMetadataFirmaProfesional = ({
        nombre = '',
        registro = 'N/A',
        codigo = 'N/A',
        textoPie = ''
    }) => {
        const metadata = {
            tipo: 'profesional',
            nombre: nombre || '',
            registroMedico: registro || 'N/A',
            codigoHabilitacion: codigo || 'N/A'
        };
        const pie = (textoPie && String(textoPie).trim()) || '';
        if (pie) {
            metadata.textoPieFirma = pie;
        }
        return metadata;
    };

    const tieneContenidoEvol = (v) => v != null && String(v).trim() !== '';

    const nombreProfesionalEvol = (evol) => {
        const n = evol?.profesional_tratante_completo;
        if (n && n !== 'null' && n !== 'No registrado') return n;
        return 'No registrado';
    };

    const firmaProfesionalImagenEvolucion = (evol) => {
        if (!evol) return '';
        if (evol.profesional_firma_blob) return evol.profesional_firma_blob;
        return evol.firma || '';
    };

    const pieFirmaProfesionalDesdeEvol = (evol) => {
        if (!evol || evol.texto_pie_firma_usuario == null || evol.texto_pie_firma_usuario === '') return '';
        return String(evol.texto_pie_firma_usuario).trim();
    };

    const metadataFirmaProfesionalEvol = (evol) =>
        construirMetadataFirmaProfesional({
            nombre: evol.profesional || '',
            registro: evol.registro_medico || 'N/A',
            codigo: evol.codigo_habilitacion || 'N/A',
            textoPie: pieFirmaProfesionalDesdeEvol(evol)
        });

    /** Secciones de contenido clínico para PDF (mismo patrón que ModalEvolucion). */
    const construirSeccionesContenidoEvolucionPdf = (evol) => {
        const secciones = [];
        const estilosTexto = { margenSuperiorMm: 0, htmlTextoCompacto: true, factorSaltoLineaPdf: 0.28, espacioPostBloqueTextoMm: 0.35 };
        const estilosBloque = { margenSuperiorMm: 2, htmlTextoCompacto: false };

        const personalizado = renderizarContenidoPersonalizadoParaPDF(evol.contenido_personalizado, { compacto: true });
        if (personalizado) {
            secciones.push({ tipo: 'texto', contenido: personalizado, estilos: estilosTexto });
        }
        if (evol.procedimiento && tieneContenidoEvol(evol.procedimiento)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Procedimiento / evolución',
                contenido: evol.procedimiento,
                estilos: estilosBloque
            });
        }
        if (evol.eventos_adversos && tieneContenidoEvol(evol.eventos_adversos)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Evento adverso',
                contenido: evol.eventos_adversos,
                estilos: estilosBloque
            });
        }
        if (evol.plan_manejo_evento_adverso && tieneContenidoEvol(evol.plan_manejo_evento_adverso)) {
            secciones.push({
                tipo: 'texto',
                titulo: 'Plan de manejo',
                contenido: evol.plan_manejo_evento_adverso,
                estilos: estilosBloque
            });
        }
        if (secciones.length === 0) {
            secciones.push({
                tipo: 'texto',
                contenido: 'Sin contenido registrado.',
                estilos: { margenSuperiorMm: 0, htmlTextoCompacto: true }
            });
        }
        return secciones;
    };

    const construirSeccionesFirmasEvolucionPdf = (evol, esIndep, nombrePaciente, documentoPaciente) => {
        const secciones = [];
        const estilosFirma = { estiloEvolucion: true, separadorPrevia: true };
        let huboFirmaProf = false;

        if (!esIndep) {
            const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                evol.profesional_tratante_completo !== 'null' &&
                evol.profesional_tratante_completo !== 'No registrado');
            const imgFirmaProf = firmaProfesionalImagenEvolucion(evol);
            if (tieneProfesionalRegistrado && imgFirmaProf) {
                secciones.push({
                    tipo: 'firma',
                    imagenBase64: imgFirmaProf,
                    metadata: metadataFirmaProfesionalEvol(evol),
                    estilos: estilosFirma
                });
                huboFirmaProf = true;
            }
        }

        if (evol.firma_paciente) {
            secciones.push({
                tipo: 'firma',
                imagenBase64: evol.firma_paciente,
                metadata: {
                    tipo: 'paciente',
                    nombrePaciente: nombrePaciente,
                    documentoPaciente: documentoPaciente
                },
                estilos: {
                    estiloEvolucion: true,
                    separadorPrevia: !huboFirmaProf,
                    margenSuperiorMm: huboFirmaProf ? 2 : 0
                }
            });
        }
        return secciones;
    };

    // Cuando se renderiza el componente, se cargan maestros e info relacionada (perfil del profesional, estados-cita, info del paciente)
    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso para atender pacientes (con fallback)
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'atenderPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('atenderPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);
        setEsAdministrativo(esUsuarioAdministrativo(userdata));

        // 🔒 VERIFICAR PERMISOS ESPECÍFICOS
        const verificarPermiso = (slug) => {
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                return userdata.permissions.some(p => p.slug === slug);
            } else if (userdata.up && userdata.up.includes(slug)) {
                return true;
            }
            return false;
        };

        setTienePermisoDocumentos(verificarPermiso('documentosPaciente'));
        setTienePermisoHistoriaClinica(puedeAccederModuloClinico(verificarPermiso('historiaClinicaPaciente'), userdata));
        setTienePermisoEvolucion(puedeAccederModuloClinico(verificarPermiso('evolucionPaciente'), userdata));
        setTienePermisoRips(puedeAccederModuloClinico(verificarPermiso('ripsPaciente'), userdata));
        setTienePermisoToxina(puedeAccederModuloClinico(verificarPermiso('toxinaPaciente'), userdata));
        setTienePermisoOdontograma(puedeAccederModuloClinico(verificarPermiso('odontogramaPaciente'), userdata));

        axios.get('/usuarios?uid=' + userdata.user_id)
            .then((response) => {
                const lista = Array.isArray(response.data) ? response.data : [];
                setProfesionalesImpresion(lista);
            })
            .catch(() => setProfesionalesImpresion([]));

        // 🆕 PARAMETRIZACIÓN FACTURADOR
        // 0 = Sí es facturador (muestra RIPS FEV y Convenio)
        // 1 = No es facturador (muestra RIPS Sin FEV)
        const facturadorValue = userdata.facturador !== undefined ? userdata.facturador : 0;
        setEsFacturador(facturadorValue === 0);
        console.log('Usuario es facturador:', facturadorValue === 0);

        // ✅ Usar axios en lugar de fetch - ya tiene el interceptor configurado
        let requestPerfil = axios.get('/perfil');

        let requestEstadosCita = axios.get('/estados-cita', {
            params: { mostrar_atencion: 1 }
        });

        const parametrosPaciente = { id: paciente_id };
        if (debeFiltrarPorProfesional(userdata)) {
            parametrosPaciente.validar_asignacion = true;
        }

        let requestPaciente = axios.get('/paciente', {
            params: parametrosPaciente
        });

        let result = Promise.all([requestPerfil, requestEstadosCita, requestPaciente]);

        result.then(
            function (response) {
                console.log('Respuestas recibidas:', response);

                // asigna información del profesional que atiende
                if (response[0] && response[0].data) {
                    setNombreProfesional(response[0].data.name + ' ' + response[0].data.lastname);
                    setEmailProfesional(response[0].data.email);
                    setEspecialidad(response[0].data.especialidad);
                    setRegistroMedico(response[0].data.registro_medico);
                    setCodigoHabilitacion(response[0].data.codigo_habilitacion);
                    setFirmaimg(response[0].data.firma_blob || response[0].data.firma || '');
                    setTextoPieFirma(response[0].data.texto_pie_firma || '');
                }

                // asigna los estados de cita del cliente
                if (response[1] && response[1].data) {
                    setEstadosCita(response[1].data);
                }

                // asigna la info del paciente
                if (response[2] && response[2].data) {
                    console.log('Datos del paciente:', response[2].data);
                    asignarInfoPaciente(response[2].data);
                }
            }
        ).catch(error => {
            console.error('Error al cargar datos:', error);

            // 🆕 PROFESIONAL INDEPENDIENTE - Manejar error de acceso denegado
            if (error.response && error.response.status === 403) {
                alert('No tienes acceso a este paciente. Solo puedes atender pacientes asignados a tu Usuario.');
                history.push('/pacientes');
                return;
            }

            alert('Error al cargar los datos del paciente. Por favor, recargue la página.');
        });

        if (!esUsuarioAdministrativo(userdata)) {
            cargarEvolucionesYHistorias();
        }
    }, []);

    // Asigna la información del paciente a los campos correspondientes
    const asignarInfoPaciente = (response) => {

        // 🔒 VALIDACIÓN DE SEGURIDAD - Verificar que no sea una empresa
        if (response[0].tipo_cliente === 1) {
            alert('Este registro corresponde a una empresa, no a un paciente. No se puede atender como paciente médico.');
            history.push('/pacientes');
            return;
        }

        // 🔒 VALIDACIÓN ADICIONAL - Los pacientes deben tener tipo_cliente = 0 o null (legacy)
        if (response[0].tipo_cliente !== null && response[0].tipo_cliente !== 0 && response[0].tipo_cliente !== 1) {
            console.warn('Tipo de cliente no reconocido:', response[0].tipo_cliente);
        }

        setPrimerNombre(response[0].primer_nombre || '');
        setSegundoNombre(response[0].segundo_nombre || '');
        setPrimerApellido(response[0].primer_apellido || '');
        setSegundoApellido(response[0].segundo_apellido || '');
        setNumeroDocumento(response[0].numero_documento || '');
        setTipoDocumento(response[0].tipo_documento || '');
        setEmail(response[0].email || '');
        setCelular(response[0].celular || '');
        setGenero(response[0].sexo || '');
        setTipoSangre(response[0].rh || '');
        setEstadoCivil(response[0].estado_civil || '');
        setFechaNacimiento(response[0].fecha_nacimiento || '');
        setFechaIngreso(response[0].fechaingreso || '');
        setReligion(response[0].religion || '');
        setCiudadNacimiento(response[0].ciudad_nacimiento || '');
        setOcupacion(response[0].ocupacion || '');
        setNacionalidad(response[0].nacionalidad || '');
        setDireccion(response[0].direccion || '');
        setCiudad(response[0].ciudad || '');
        setZona(response[0].zona || '');
        setTelefono(response[0].telefono || '');
        setVinculacion(response[0].vinculacion || '');
        setEps(response[0].eps || '');
        setNombreEps(response[0].nombre_eps || '');
        setClasificacionRiesgo(response[0].clasificacion_riesgo || '');
        setDescripcionClasificacion(response[0].descripcion_clasificacion || '');
        setMedioPublicitario(response[0].nombre_medio || '');
        setReferido(response[0].referido_por || '');
        setNombreAcompanante(response[0].nombre_acompanante || '');
        setTelefonoAcompanante(response[0].telefono_acompanante || '');
        setDocumentoAcompanante(response[0].doc_acompanante || '');
        setEmailAcompanante(response[0].email_acompanante || '');
        setParentescoAcompanante(response[0].parentesco_acompanante || '');
        setNombreResponsable(response[0].nombre_responsable || '');
        setTelefonoResponsable(response[0].telefono_responsable || '');
        setDocResponsable(response[0].doc_responsable || '');
        setEmailResponsable(response[0].email_responsable || '');
        setParentescoResponsable(response[0].parentesco_responsable || '');
        setNombreMadre(response[0].nombre_madre || '');
        setDocumentoMadre(response[0].documento_madre || '');
        setTelefonoMadre(response[0].telefono_madre || '');
        setOcupacionMadre(response[0].ocupacion_madre || '');
        setNombrePadre(response[0].nombre_padre || '');
        setDocumentoPadre(response[0].documento_padre || '');
        setTelefonoPadre(response[0].telefono_padre || '');
        setOcupacionPadre(response[0].ocupacion_padre || '');
        setEstadoPaciente(response[0].estado || '');
        setConvenio(response[0].nombre_convenio || '');

        setPaisNacimiento(response[0].nombre_pais_nacimiento || '');
        setIdPaisNacimiento(response[0].id_pais_nacimiento || '');

        setIdCiudadNacimiento(response[0].id_ciudad_nacimiento || '');
        setCiudadNacimiento(response[0].nombre_ciudad_nacimiento || '');

        setIdCiudad(response[0].id_ciudad_residencia || '');
        setCiudad(response[0].nombre_ciudad_residencia || '');

        setPaisResidencia(response[0].nombre_pais_residencia || '');
        setIdPaisResidencia(response[0].id_pais_residencia || '');

        setNacionalidad(response[0].nombre_pais_nacionalidad || '');
        setIdNacionalidad(response[0].id_pais_nacionalidad || '');

        let edadEnDias = parseInt(response[0].edad_paciente);

        if (edadEnDias > 365) {
            setEdad(Math.floor(edadEnDias / 365) + ' años');
            // Si el paciente es mayor de edad se oculta panel de información para menores de edad
            if (edadEnDias > 6570) {
                setEstiloInfoMenores({ display: 'none' });
            }
        }
        else if (edadEnDias < 30) {
            setEdad(edadEnDias + ' días');
        }
        else {
            setEdad(Math.floor(edadEnDias / 30) + ' meses');
        }

        if (response[0].imagen_perfil) {
            // El backend ya devuelve la URL completa con asset()
            setPerfilimg(response[0].imagen_perfil);
        }

        setEtnia(response[0].etnia);
        setIdentidadGenero(response[0].identidad_genero);
        setDiscapacidad(response[0].discapacidad);
        setProfesionalAsignado(response[0].nombre_profesional_asignado || '');
    }

    // Si la clasificación de riesgo es media o alta se muestra el popup de advertencia al profesional...
    useEffect(() => {
        if ((clasificacionRiesgo == 'medio' || clasificacionRiesgo == 'alto') && descripcionClasificacion) {
            setShow(true);
        }
    }, [clasificacionRiesgo, descripcionClasificacion]);



    // Cambia el estado de la cita (al hacer clic en alguno de los botones del último panel)
    function cambiarEstadoCita(idCita, nuevoEstadoCita, nombreEstado) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        const config = {
            id: idCita,
            estado_cita: nuevoEstadoCita,
        }

        axios.put('editar-estado-cita', config)
            .then(response => {
                // Volver a agenda
                localStorage.setItem('cita_atendida', JSON.stringify({ id: idCita, estado: nombreEstado, id_paciente: paciente_id }));

                const proximaCita = {
                    id_profesional: userdata.user_id,
                    nombre_profesional: userdata.user_name + ' ' + userdata.user_lastname,
                    primer_nombre: primerNombre,
                    segundo_nombre: segundoNombre,
                    primer_apellido: primerApellido,
                    segundo_apellido: segundoApellido,
                    numero_documento: numeroDocumento,
                    tipo_documento: tipoDocumento,
                    email: email,
                    celular: celular,
                    id_paciente: pacienteId
                };

                localStorage.setItem('proximaCita', JSON.stringify(proximaCita));
                history.push('/home');
            })
            .catch(error => {
                console.log(error);
            });
    }


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    // 🆕 Estados para dropdowns de atención médica
    const [showDropdownHistoriaClinica, setShowDropdownHistoriaClinica] = useState(false);
    const [showDropdownHistoriaClinicaConsulta, setShowDropdownHistoriaClinicaConsulta] = useState(false);
    const [showDropdownRips, setShowDropdownRips] = useState(false);
    const [showDropdownDocumentos, setShowDropdownDocumentos] = useState(false);
    const [showDropdownGraficos, setShowDropdownGraficos] = useState(false);

    const [showEvolucion, setShowEvolucion] = useState(false);
    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // const [showHistoriaClinica, setShowHistoriaClinica] = useState(false);
    const [showExamenes, setShowExamenes] = useState(false);
    const [showArchivosClinicos, setShowArchivosClinicos] = useState(false);
    const [showFormulas, setShowFormulas] = useState(false);
    const [showOtrosDocumentos, setShowOtrosDocumentos] = useState(false);
    const [showIncapacidades, setShowIncapacidades] = useState(false);
    const [showRecomendaciones, setShowRecomendaciones] = useState(false);
    const [showRemisiones, setShowRemisiones] = useState(false);
    const [showContraremisiones, setShowContraremisiones] = useState(false);
    const [showConsentimientos, setShowConsentimientos] = useState(false);
    const [showRipsSinFev, setShowRipsSinFev] = useState(false);
    const [showRipsFev, setShowRipsFev] = useState(false);
    const [showRipsConvenio, setShowRipsConvenio] = useState(false);
    const [showOdontograma, setShowOdontograma] = useState(false);

    // 🆕 Estado para controlar si el usuario es facturador
    const [esFacturador, setEsFacturador] = useState(false);


    // 🆕 Función para cerrar todos los acordeones al abrir un modal
    const cerrarTodosAcordeones = () => {
        setAcordeonInfoPaciente(false);
        setAcordeonAtencion(false);
    };

    const [cargarHistorialEvolucion, setCargarHistorialEvolucion] = useState(false);
    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // const [cargarHistorialHistoriaClinica, setCargarHistorialHistoriaClinica] = useState(false);
    const [cargarHistorialExamenes, setCargarHistorialExamenes] = useState(false);
    const [cargarHistorialFormulas, setCargarHistorialFormulas] = useState(false);
    const [cargarHistorialOtrosDocumentos, setCargarHistorialOtrosDocumentos] = useState(false);
    const [cargarHistorialIncapacidades, setCargarHistorialIncapacidades] = useState(false);
    const [cargarHistorialRecomendaciones, setCargarHistorialRecomendaciones] = useState(false);
    const [cargarHistorialRemisiones, setCargarHistorialRemisiones] = useState(false);
    const [cargarHistorialContraremisiones, setCargarHistorialContraremisiones] = useState(false);
    const [cargarHistorialConsentimientos, setCargarHistorialConsentimientos] = useState(false);
    const [cargarHistorialRipsSinFev, setCargarHistorialRipsSinFev] = useState(false);
    const [cargarHistorialRipsFev, setCargarHistorialRipsFev] = useState(false);
    const [cargarHistorialRipsConvenio, setCargarHistorialRipsConvenio] = useState(false);

    // 🆕 Estados para el botón "Imprimir Historia"
    const [evoluciones, setEvoluciones] = useState([]);
    const [historiasClinicas, setHistoriasClinicas] = useState([]);
    const [historiasClinicasJson, setHistoriasClinicasJson] = useState([]); // 🆕 Historias JSON
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [showModalGenerandoPDF, setShowModalGenerandoPDF] = useState(false); // 🆕 Modal de carga PDF
    const [showModalFiltrosImpresion, setShowModalFiltrosImpresion] = useState(false);
    const [profesionalesImpresion, setProfesionalesImpresion] = useState([]);
    const [filtroImpresionUsuario, setFiltroImpresionUsuario] = useState('');
    const [filtroImpresionFechaInicio, setFiltroImpresionFechaInicio] = useState('');
    const [filtroImpresionFechaFin, setFiltroImpresionFechaFin] = useState('');
    const [filtroImpresionTodos, setFiltroImpresionTodos] = useState(true);

    /**
     * Refuerzo en cliente: filtra por profesional/fechas si el backend no aplicó el criterio.
     */
    const aplicarFiltrosImpresionConsolidada = (lista, filtros, obtenerUserId, obtenerFecha) => {
        if (!Array.isArray(lista) || filtros.todos) {
            return lista || [];
        }

        let resultado = lista;
        const { userId, fechaInicio, fechaFin } = filtros;

        if (userId) {
            const uid = String(userId);
            resultado = resultado.filter((item) => String(obtenerUserId(item) || '') === uid);
        }

        if (fechaInicio) {
            resultado = resultado.filter((item) => {
                const f = obtenerFecha(item);
                return f && String(f).slice(0, 10) >= fechaInicio;
            });
        }

        if (fechaFin) {
            resultado = resultado.filter((item) => {
                const f = obtenerFecha(item);
                return f && String(f).slice(0, 10) <= fechaFin;
            });
        }

        return resultado;
    };

    /** Excluye borradores (estado=1) del PDF consolidado de AtenderPaciente2 */
    const filtrarHistoriasJsonSinBorrador = (lista) =>
        (Array.isArray(lista) ? lista : []).filter((item) => Number(item.estado ?? 0) === ESTADO_EVOLUCION_GUARDADA);

    const filtrarEvolucionesSinBorrador = (lista) =>
        (Array.isArray(lista) ? lista : []).filter((item) => Number(item.estado ?? ESTADO_EVOLUCION_GUARDADA) === ESTADO_EVOLUCION_GUARDADA);

    /**
     * Snapshot fresco para PDF consolidado (evoluciones + historias JSON).
     */
    const obtenerSnapshotHistorialConsolidada = async (filtros = {}) => {
        const { userId, fechaInicio, fechaFin, todos } = filtros;
        const userdataSnap = getUserData();
        if (!userdataSnap) {
            return null;
        }
        const esAdmin = esUsuarioAdministrativo(userdataSnap);
        const parametros = { id: paciente_id, impresion_consolidada: true };
        const parametrosJson = { paciente_id, impresion_consolidada: true };
        if (debeFiltrarPorProfesional(userdataSnap) && !esAdmin) {
            parametros.validar_asignacion = true;
        }
        if (!todos && userId) {
            parametros.user_id = userId;
            parametrosJson.user_id = userId;
        }
        if (!todos && fechaInicio) {
            parametros.fecha_desde = fechaInicio;
            parametrosJson.fecha_desde = fechaInicio;
        }
        if (!todos && fechaFin) {
            parametros.fecha_hasta = fechaFin;
            parametrosJson.fecha_hasta = fechaFin;
        }

        const leerLista = async (etiqueta, url, params) => {
            try {
                const r = await axios.get(url, { params });
                return Array.isArray(r.data) ? r.data : [];
            } catch (e) {
                console.warn(
                    `[PDF consolidado] ${etiqueta} no disponible (${e.response?.status ?? 'red'}):`,
                    url
                );
                return [];
            }
        };

        const [evolucionesSnap, historiasClinicasJsonSnap] = await Promise.all([
            leerLista('Evoluciones', '/evoluciones', parametros),
            leerLista('Historias JSON', '/historia-clinica-json', parametrosJson)
        ]);

        const filtrosAplicar = { userId, fechaInicio, fechaFin, todos };

        return {
            evoluciones: aplicarFiltrosImpresionConsolidada(
                filtrarEvolucionesSinBorrador(evolucionesSnap),
                filtrosAplicar,
                (item) => item.users_id ?? item.user_id,
                (item) => item.fecha || item.hora_inicial
            ),
            historiasClinicasJson: aplicarFiltrosImpresionConsolidada(
                filtrarHistoriasJsonSinBorrador(historiasClinicasJsonSnap),
                filtrosAplicar,
                (item) => item.user_id,
                (item) => item.fecha
            )
        };
    };

    // 🆕 Función para cargar evoluciones y historias clínicas
    const cargarEvolucionesYHistorias = async () => {
        const userdata = getUserData();
        if (!userdata || esUsuarioAdministrativo(userdata)) return;

        const parametros = { id: paciente_id };
        if (debeFiltrarPorProfesional(userdata)) {
            parametros.validar_asignacion = true;
        }

        const config = { params: parametros };

        try {
            // Cargar evoluciones
            const responseEvoluciones = await axios.get('/evoluciones', config);
            setEvoluciones(responseEvoluciones.data || []);

            // Cargar historias clínicas (sistema antiguo)
            const responseHistorias = await axios.get('/historia-clinica', config);
            setHistoriasClinicas(responseHistorias.data || []);

            // 🆕 Cargar historias clínicas JSON (sistema nuevo)
            const parametrosJson = { paciente_id: paciente_id };
            if (debeFiltrarPorProfesional(userdata)) {
                parametrosJson.validar_asignacion = true;
            }
            const responseHistoriasJson = await axios.get('/historia-clinica-json', { params: parametrosJson });
            setHistoriasClinicasJson(responseHistoriasJson.data || []);

            // Cargar encabezado personalizado (opcional)
            try {
                const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
                console.log('🔍 Respuesta encabezado personalizado:', responseEncabezado);
                if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                    console.log('✅ Encabezado personalizado cargado:', responseEncabezado.data);
                    setEncabezadoPersonalizado(responseEncabezado.data);
                } else {
                    console.log('⚠️ Encabezado personalizado no disponible o deshabilitado');
                }
            } catch (encabezadoError) {
                if (encabezadoError?.response?.status === 404) {
                    console.log('ℹ️ Encabezado personalizado no configurado para este usuario');
                } else {
                    console.log('Error cargando encabezado personalizado:', encabezadoError);
                }
            }
        } catch (error) {
            console.log('Error cargando datos para historia consolidada:', error);
            if (error.response && error.response.status === 403) {
                console.log('Acceso denegado a algunos registros del paciente');
            }
            // 🆕 Intentar cargar encabezado aunque fallen otros datos
            try {
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
                if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                    console.log('✅ Encabezado personalizado cargado en catch:', responseEncabezado.data);
                    setEncabezadoPersonalizado(responseEncabezado.data);
                }
            } catch (encabezadoError) {
                console.log('Error cargando encabezado personalizado:', encabezadoError);
            }
        }
    };

    function abrirEvolucion() {
        cerrarTodosAcordeones();
        history.push(`/evolucion-paciente?id=${paciente_id}`);
    }
    function cerrarEvolucion() {
        setShowEvolucion(false);
        setCargarHistorialEvolucion(false);
    }

    // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
    // function abrirHistoriaClinica() {
    //     cerrarTodosAcordeones();
    //     setShowHistoriaClinica(true);
    //     setCargarHistorialHistoriaClinica(true);
    // }
    // function cerrarHistoriaClinica() {
    //     setShowHistoriaClinica(false);
    //     setCargarHistorialHistoriaClinica(false);
    // }

    function abrirHistoriaClinicaJson() {
        cerrarTodosAcordeones();
        history.push(`/historia-clinica-json?id=${pacienteId}`);
    }
    function cerrarHistoriaClinicaJson() {
        // Ya no es necesario, pero mantenemos por compatibilidad
    }


    function abrirExamenes() {
        cerrarTodosAcordeones();
        setShowExamenes(true);
        setCargarHistorialExamenes(true);
    }
    function cerrarExamenes() {
        setShowExamenes(false);
        setCargarHistorialExamenes(false);
    }

    function abrirArchivosClinicos() {
        cerrarTodosAcordeones();
        setShowArchivosClinicos(true);
    }
    function cerrarArchivosClinicos() {
        setShowArchivosClinicos(false);
    }


    function abrirFormulas() {
        cerrarTodosAcordeones();
        setShowFormulas(true);
        setCargarHistorialFormulas(true);
    }
    function cerrarFormulas() {
        setShowFormulas(false);
        setCargarHistorialFormulas(false);
    }

    function abrirOtrosDocumentos() {
        cerrarTodosAcordeones();
        setShowOtrosDocumentos(true);
        setCargarHistorialOtrosDocumentos(true);
    }
    function cerrarOtrosDocumentos() {
        setShowOtrosDocumentos(false);
        setCargarHistorialOtrosDocumentos(false);
    }


    function abrirIncapacidades() {
        cerrarTodosAcordeones();
        setShowIncapacidades(true);
        setCargarHistorialIncapacidades(true);
    }
    function cerrarIncapacidades() {
        setShowIncapacidades(false);
        setCargarHistorialIncapacidades(false);
    }


    function abrirRecomendaciones() {
        cerrarTodosAcordeones();
        setShowRecomendaciones(true);
        setCargarHistorialRecomendaciones(true);
    }
    function cerrarRecomendaciones() {
        setShowRecomendaciones(false);
        setCargarHistorialRecomendaciones(false);
    }


    function abrirRemisiones() {
        cerrarTodosAcordeones();
        setShowRemisiones(true);
        setCargarHistorialRemisiones(true);
    }
    function cerrarRemisiones() {
        setShowRemisiones(false);
        setCargarHistorialRemisiones(false);
    }


    function abrirContraremisiones() {
        cerrarTodosAcordeones();
        setShowContraremisiones(true);
        setCargarHistorialContraremisiones(true);
    }
    function cerrarContraremisiones() {
        setShowContraremisiones(false);
        setCargarHistorialContraremisiones(false);
    }


    function abrirConsentimientos() {
        cerrarTodosAcordeones();
        setShowConsentimientos(true);
        setCargarHistorialConsentimientos(true);
    }
    function cerrarConsentimientos() {
        setShowConsentimientos(false);
        setCargarHistorialConsentimientos(false);
    }

    function abrirRipsFev() {
        cerrarTodosAcordeones();
        setShowRipsFev(true);
        setCargarHistorialRipsFev(true);
    }
    function cerrarRipsFev() {
        setShowRipsFev(false);
        setCargarHistorialRipsFev(false);
    }

    function abrirRipsSinFev() {
        cerrarTodosAcordeones();
        setShowRipsSinFev(true);
        setCargarHistorialRipsSinFev(true);
    }
    function cerrarRipsSinFev() {
        setShowRipsSinFev(false);
        setCargarHistorialRipsSinFev(false);
    }

    function abrirRipsConvenio() {
        cerrarTodosAcordeones();
        setShowRipsConvenio(true);
        setCargarHistorialRipsConvenio(true);
    }
    function cerrarRipsConvenio() {
        setShowRipsConvenio(false);
        setCargarHistorialRipsConvenio(false);
    }

    function abrirOdontograma() {
        cerrarTodosAcordeones();
        setShowOdontograma(true);
    }

    function cerrarOdontograma() {
        setShowOdontograma(false);
    }

    function abrirToxina() {
        cerrarTodosAcordeones();
        // Navegar a página completa en lugar de modal
        history.push(`/toxina-botulinica?id=${paciente_id}`);
    }




    function guardarCambios(msg) {
        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) }, 800);
    }


    function seccionEstadosCita(idcita) {
        if (idcita) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title w-100">
                                    <a className="d-block w-100">
                                        Estado de la Cita
                                    </a>
                                </h4>
                            </div>
                            <div className="card-body">

                                {
                                    estadosCita.map((estadoCita) =>
                                        <button className="btn btn-primary" style={{ marginRight: '8px' }} onClick={() => cambiarEstadoCita(idcita, estadoCita.id, estadoCita.nombre)}>{estadoCita.nombre}</button>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    const getInfoAnamnesisPDF = () => {
        try {
            let contenidoInfoGeneral = '';
            let contenidoPaciente = '';

            const elementoInfoGeneral = document.getElementById('panel-info-general');
            const elementoInfoPaciente = document.getElementById('panel-info-paciente');

            if (elementoInfoGeneral) {
                contenidoInfoGeneral = elementoInfoGeneral.innerHTML;
            }

            if (elementoInfoPaciente) {
                contenidoPaciente = elementoInfoPaciente.innerHTML;
            }

            return '<div className="contenedor-pdf">' + contenidoInfoGeneral + contenidoPaciente + '</div>';
        } catch (error) {
            console.error('Error al obtener información para PDF:', error);
            return '<div className="contenedor-pdf"><p>Error al cargar información del paciente</p></div>';
        }
    }

    const htmlTieneContenidoVisible = (html) =>
        (html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().length > 0;

    /** Solo acordeón "Información del Paciente" (domicilio, EPS, etc.): evita duplicar cabecera con panel-info-general. */
    const getInfoPacienteDetalleParaPdf = () => {
        try {
            const el = document.getElementById('panel-info-paciente');
            if (!el) return '';
            return '<div class="contenedor-pdf">' + el.innerHTML + '</div>';
        } catch (error) {
            console.error('Error al obtener detalle paciente para PDF:', error);
            return '';
        }
    };

    // 🆕 Abrir modal de filtros antes de imprimir historia consolidada
    const abrirModalImpresionHistoria = () => {
        setFiltroImpresionUsuario('');
        setFiltroImpresionFechaInicio('');
        setFiltroImpresionFechaFin('');
        setFiltroImpresionTodos(true);
        setShowModalFiltrosImpresion(true);
    };

    const confirmarImpresionHistoria = async () => {
        const todos = document.getElementById('filtroImpresionTodos')?.checked ?? filtroImpresionTodos;
        const userId = document.getElementById('filtroImpresionUsuario')?.value ?? filtroImpresionUsuario;
        const fechaInicio = document.getElementById('filtroImpresionFechaInicio')?.value ?? filtroImpresionFechaInicio;
        const fechaFin = document.getElementById('filtroImpresionFechaFin')?.value ?? filtroImpresionFechaFin;

        if (!todos && fechaInicio && fechaFin && fechaInicio > fechaFin) {
            alert('La fecha de inicio no puede ser posterior a la fecha fin.');
            return;
        }
        setShowModalFiltrosImpresion(false);
        setShowModalGenerandoPDF(true);
        await new Promise((resolve) => setTimeout(resolve, 50));
        await generarPDFHistoriaConsolidada({
            userId,
            fechaInicio,
            fechaFin,
            todos,
        });
    };

    // 🆕 Función que genera el PDF (separada para mejor control del modal)
    const generarPDFHistoriaConsolidada = async (filtrosImpresion = {}) => {
        try {
            console.log('📄 Iniciando generación de PDF consolidado');
            const esProfesionalIndependiente = esUsuarioProfesionalIndependiente();

            let evolucionesPdf = [];
            let historiasClinicasJsonPdf = [];
            let notasAclaratoriasPdf = [];
            const snap = await obtenerSnapshotHistorialConsolidada(filtrosImpresion);
            if (snap) {
                evolucionesPdf = snap.evoluciones;
                historiasClinicasJsonPdf = snap.historiasClinicasJson;
                setEvoluciones(snap.evoluciones);
                setHistoriasClinicasJson(snap.historiasClinicasJson);
            }
            notasAclaratoriasPdf = await cargarNotasAclaratoriasPacientePdf(paciente_id);
            
            // 🆕 Cargar encabezado personalizado justo antes de generar el PDF
            let encabezadoParaPDF = encabezadoPersonalizado;
            
            if (!encabezadoParaPDF) {
                console.log('⚠️ Encabezado no disponible en estado, intentando cargar...');
                try {
                    const userdata = JSON.parse(localStorage.getItem('userdata'));
                    const responseEncabezado = await axios.get('/encabezado-personalizado?uid=' + userdata.user_id);
                    if (responseEncabezado.status === 200 && responseEncabezado.data && responseEncabezado.data.estado === 1) {
                        console.log('✅ Encabezado personalizado cargado para PDF:', responseEncabezado.data);
                        encabezadoParaPDF = responseEncabezado.data;
                        // También actualizar el estado para futuras generaciones
                        setEncabezadoPersonalizado(responseEncabezado.data);
                    } else {
                        console.log('⚠️ Encabezado personalizado no disponible o deshabilitado');
                    }
                } catch (encabezadoError) {
                    console.log('❌ Error cargando encabezado personalizado:', encabezadoError);
                }
            } else {
                console.log('✅ Usando encabezado del estado');
            }
            
            console.log('🔍 Estado encabezadoPersonalizado:', encabezadoParaPDF);
            
            // Preparar datos del paciente
            const nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
            const documentoCompleto = `${tipoDocumento || ''} - ${numeroDocumento || ''}`;

            console.log('👤 Datos del paciente:', { nombreCompleto, documentoCompleto });
            console.log('📊 Datos disponibles:', {
                evoluciones: evolucionesPdf?.length || 0,
                historiasClinicasJson: historiasClinicasJsonPdf?.length || 0,
                encabezadoPersonalizado: !!encabezadoParaPDF
            });

            // Preparar secciones del documento
            const secciones = [];

            // 1. Título principal (franja gris, mismo patrón que ModalHistoriaClinicaJson)
            secciones.push({
                tipo: 'banner',
                titulo: 'HISTORIA CONSOLIDADA DEL PACIENTE',
                contenido: 'HISTORIA CONSOLIDADA DEL PACIENTE'
            });

            // 2. Información del Paciente - Datos Básicos
            secciones.push({
                tipo: 'banner',
                titulo: 'INFORMACIÓN DEL PACIENTE',
                contenido: 'INFORMACIÓN DEL PACIENTE'
            });

            secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'Nombres y Apellidos', valor: nombreCompleto },
                        { etiqueta: 'Documento', valor: documentoCompleto },
                        { etiqueta: 'Fecha de Nacimiento', valor: formatearFechaNacimientoLegible(fechaNacimiento) },
                        { etiqueta: 'Edad', valor: edad || 'No registrada' },
                        { etiqueta: 'Sexo', valor: sexoBiologico[genero] || genero || 'No registrado' },
                        { etiqueta: 'Tipo de Sangre', valor: tipoSangre?.toUpperCase() || 'No registrado' },
                        { etiqueta: 'Religión', valor: religion || 'No registrada' },
                        { etiqueta: 'Email', valor: email || 'No registrado' },
                        { etiqueta: 'Celular', valor: celular || 'No registrado' },
                        { etiqueta: 'Estado Civil', valor: estadoCivil || 'No registrado' },
                        { etiqueta: 'Ocupación', valor: ocupacion || 'No registrada' },
                        { etiqueta: 'Clasificación de Riesgo', valor: clasificacionRiesgo?.toUpperCase() || 'No registrada' }
                    ]
                }
            });

            // Información de Domicilio
            secciones.push({
                tipo: 'banner',
                titulo: 'INFORMACIÓN DE DOMICILIO',
                contenido: 'INFORMACIÓN DE DOMICILIO'
            });

            secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'Dirección', valor: direccion || 'No registrada' },
                        { etiqueta: 'Ciudad', valor: ciudad || 'No registrada' },
                        { etiqueta: 'País', valor: paisResidencia || 'No registrado' },
                        { etiqueta: 'Teléfono', valor: telefono || 'No registrado' }
                    ]
                }
            });

            // Información de Salud
            secciones.push({
                tipo: 'banner',
                titulo: 'INFORMACIÓN DE SALUD',
                contenido: 'INFORMACIÓN DE SALUD'
            });

            const filasInfoSalud = [
                { etiqueta: 'EPS/Aseguradora', valor: nombreEps || 'No registrada' },
                { etiqueta: 'Vinculación', valor: vinculacion?.toUpperCase() || 'No registrada' },
                { etiqueta: 'Convenio', valor: convenio || 'No registrado' },
                { etiqueta: 'Discapacidad', valor: discapacidades[discapacidad] || 'Ninguna' }
            ];

            if (etnia) {
                filasInfoSalud.push({ etiqueta: 'Etnia', valor: etnias[etnia] || 'No registrada' });
            }
            if (identidadGenero) {
                filasInfoSalud.push({ etiqueta: 'Identidad de Género', valor: identidadesGenero[identidadGenero] || 'No registrada' });
            }

            secciones.push({
                tipo: 'tabla-datos',
                datos: { filas: filasInfoSalud }
            });

            // Profesional Asignado (si existe)
            if (profesionalAsignado) {
                secciones.push({
                    tipo: 'banner',
                    titulo: 'PROFESIONAL ASIGNADO',
                    contenido: 'PROFESIONAL ASIGNADO'
                });

                secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'Profesional', valor: profesionalAsignado }
                        ]
                    }
                });
            }

            // Acompañante (si existe)
            if (nombreAcompanante || telefonoAcompanante || parentescoAcompanante || documentoAcompanante || emailAcompanante) {
                secciones.push({
                    tipo: 'banner',
                    titulo: 'ACOMPAÑANTE',
                    contenido: 'ACOMPAÑANTE'
                });

                secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'Nombre', valor: nombreAcompanante || 'No registrado' },
                            { etiqueta: 'Teléfono', valor: telefonoAcompanante || 'No registrado' },
                            { etiqueta: 'Parentesco', valor: parentescoAcompanante || 'No registrado' },
                            { etiqueta: 'Documento', valor: documentoAcompanante || 'No registrado' },
                            { etiqueta: 'Email', valor: emailAcompanante || 'No registrado' },
                        ]
                    }
                });
            }

            // Responsable (si existe)
            if (nombreResponsable || telefonoResponsable || parentescoResponsable || docResponsable || emailResponsable) {
                secciones.push({
                    tipo: 'banner',
                    titulo: 'RESPONSABLE',
                    contenido: 'RESPONSABLE'
                });

                secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'Nombre', valor: nombreResponsable || 'No registrado' },
                            { etiqueta: 'Teléfono', valor: telefonoResponsable || 'No registrado' },
                            { etiqueta: 'Parentesco', valor: parentescoResponsable || 'No registrado' },
                            { etiqueta: 'Documento', valor: docResponsable || 'No registrado' },
                            { etiqueta: 'Email', valor: emailResponsable || 'No registrado' },
                        ]
                    }
                });
            }

            // 3. EVOLUCIONES — mismo estilo sobrio que ModalEvolucion (imprimirConsolidado)
            if (evolucionesPdf && evolucionesPdf.length > 0) {
                secciones.push({ tipo: 'salto-pagina' });

                secciones.push({
                    tipo: 'subtitulo',
                    contenido: 'HISTORIAL DE EVOLUCIONES',
                    estilos: {
                        fontSize: 11,
                        espacioDespuesMm: 4,
                        margenSuperiorMm: 2
                    }
                });

                evolucionesPdf.forEach((evol, index) => {
                    if (index > 0) {
                        secciones.push({
                            tipo: 'rule',
                            estilos: { margenSuperiorMm: 6, espacioDespuesMm: 4 }
                        });
                    }
                    secciones.push({
                        tipo: 'metadata-superior-evolucion',
                        paciente: nombreCompleto,
                        documento: documentoCompleto,
                        profesional: nombreProfesionalEvol(evol),
                        fechaHora: obtenerFechaHoraVisualEvolucion(evol),
                        estilos: { fontSize: 10, margenSuperiorMm: index > 0 ? 2 : 0, espacioDespuesMm: 1 }
                    });
                    secciones.push({
                        tipo: 'rule',
                        estilos: { margenSuperiorMm: 2, espacioDespuesMm: 4 }
                    });
                    secciones.push(...construirSeccionesContenidoEvolucionPdf(evol));
                    secciones.push(...construirSeccionesNotasAclaratoriasPdf(evol.id, 'evolucion', notasAclaratoriasPdf));
                    secciones.push(...construirSeccionesFirmasEvolucionPdf(
                        evol,
                        esProfesionalIndependiente,
                        nombreCompleto,
                        documentoCompleto
                    ));
                });
            }

            // 4. HISTORIAS CLÍNICAS JSON - Agregar cada historia del sistema nuevo
            if (historiasClinicasJsonPdf && historiasClinicasJsonPdf.length > 0) {
                // Forzar que la primera historia clínica JSON inicie en hoja nueva
                secciones.push({ tipo: 'salto-pagina' });

                // Banner de sección (sin salto de página forzado - dejar que la paginación automática lo maneje)
                secciones.push({
                    tipo: 'banner',
                    titulo: 'HISTORIAS CLÍNICAS',
                    contenido: 'HISTORIAS CLÍNICAS'
                });

                historiasClinicasJsonPdf.forEach((historia, index) => {
                    if (index > 0) {
                        secciones.push({ tipo: 'salto-pagina' });
                    }

                    // Nombre de la plantilla como banner
                    const nombrePlantilla = historia.plantilla_nombre || 'Historia Clínica';
                    const tituloPlantilla = nombrePlantilla.toUpperCase();
                    secciones.push({
                        tipo: 'banner',
                        titulo: tituloPlantilla,
                        contenido: tituloPlantilla
                    });

                    // Tabla de fecha y profesional
                    secciones.push({
                        tipo: 'tabla-datos',
                        datos: {
                            filas: [
                                { etiqueta: 'FECHA Y HORA', valor: obtenerFechaHoraVisual(historia.fecha) },
                                { etiqueta: 'PROFESIONAL TRATANTE', valor: String(historia.profesional || '') }
                            ]
                        }
                    });

                    // Procesar datos de la historia (secciones con tablas)
                    try {
                        const datos = typeof historia.datos === 'string' 
                            ? JSON.parse(historia.datos) 
                            : historia.datos;
                        const estructura = typeof historia.plantilla_estructura === 'string' 
                            ? JSON.parse(historia.plantilla_estructura) 
                            : historia.plantilla_estructura;
                        
                        if (estructura && estructura.secciones && Array.isArray(estructura.secciones)) {
                            estructura.secciones.forEach(seccion => {
                                // Verificar si la sección tiene campos con valores
                                const filasSeccion = [];
                                
                                if (seccion.campos && Array.isArray(seccion.campos)) {
                                    seccion.campos.forEach(campo => {
                                        const valor = datos[campo.id];
                                        if (valor !== undefined && valor !== null && valor !== '') {
                                            // Formatear valor según tipo de campo
                                            let valorFormateado = valor;
                                            if (campo.tipo === 'checkbox') {
                                                valorFormateado = valor ? 'Sí' : 'No';
                                            } else if (campo.tipo === 'textarea') {
                                                valorFormateado = String(valor).replace(/\r\n/g, '\n');
                                            }
                                            
                                            filasSeccion.push({
                                                etiqueta: campo.label,
                                                valor: valorFormateado
                                            });
                                        }
                                    });
                                }
                                
                                // Solo agregar sección si tiene contenido
                                if (filasSeccion.length > 0) {
                                    // Agregar título de sección como banner
                                    secciones.push({
                                        titulo: seccion.titulo,
                                        tipo: 'banner',
                                        contenido: seccion.titulo
                                    });
                                    
                                    // Agregar datos de la sección
                                    secciones.push({
                                        tipo: 'tabla-datos',
                                        datos: {
                                            filas: filasSeccion
                                        }
                                    });
                                }
                            });
                        }
                    } catch (error) {
                        console.error('Error parseando datos de historia:', error);
                    }

                    secciones.push(...construirSeccionesNotasAclaratoriasPdf(historia.id, 'historia', notasAclaratoriasPdf));

                    const firmaSrcHcJson = (historia.firma_final || historia.firma) || '';
                    if (!esProfesionalIndependiente && historia.profesional && firmaSrcHcJson) {
                        const firmaMetadataHc = construirMetadataFirmaProfesional({
                            nombre: historia.profesional || '',
                            registro: historia.registro_medico || 'N/A',
                            codigo: historia.codigo_habilitacion || 'N/A',
                            textoPie: historia.texto_pie_firma_usuario || ''
                        });
                        secciones.push({
                            tipo: 'firma',
                            imagenBase64: firmaSrcHcJson,
                            metadata: firmaMetadataHc
                        });
                    }
                });
            }

            if (esProfesionalIndependiente && firmaimg) {
                secciones.push({
                    tipo: 'firmas-grupo',
                    firmas: [{
                        imagenBase64: firmaimg,
                        metadata: construirMetadataFirmaProfesional({
                            nombre: nombreProfesional || '',
                            registro: registroMedico || 'N/A',
                            codigo: codigoHabilitacion || 'N/A',
                            textoPie: textoPieFirma || ''
                        })
                    }]
                });
            }

            // Configuración del PDF
            const config = {
                filename: `historia-consolidada-${numeroDocumento}.pdf`,
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoParaPDF ? {
                    izquierda: encabezadoParaPDF.izquierda || '',
                    centro: encabezadoParaPDF.centro || '',
                    derecha: encabezadoParaPDF.derecha || ''
                } : null,
                secciones: secciones,
                margenes: {
                    top: 20,
                    bottom: 20,
                    left: 15,
                    right: 15
                }
            };

            console.log('⚙️ Configuración del PDF:', {
                filename: config.filename,
                tieneEncabezado: !!config.encabezadoPersonalizado,
                encabezado: config.encabezadoPersonalizado,
                numSecciones: config.secciones.length
            });

            // Generar PDF con texto nativo (await porque es async)
            const pdf = await generarPdfConTextoNativo(config);

            // Abrir en nueva ventana e invocar impresión (mismo criterio que ModalEvolucion al imprimir PDF)
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const ventana = window.open(url, '_blank');

            if (ventana) {
                ventana.onload = function () {
                    setTimeout(() => {
                        try {
                            ventana.print();
                        } catch (e) {
                            console.warn('No se pudo abrir el diálogo de impresión en la ventana del PDF:', e);
                        }
                    }, 500);
                };
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.print();
                        } catch (e) {
                            console.warn('Impresión vía iframe falló:', e);
                        }
                    }, 500);
                };
            }

            // Cerrar modal de carga
            setShowModalGenerandoPDF(false);

        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
            setShowModalGenerandoPDF(false);
        }
    };

    // 🆕 Función helper para renderizar contenido personalizado en PDF
    const renderizarContenidoPersonalizadoPDF = (contenidoPersonalizado) => {
        if (!contenidoPersonalizado) return '';

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return '';
        }

        let resultado = '';
        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                if (campo.tipo === 'checkbox') {
                    if (campo.check) {
                        resultado += `
                            <div style="margin-bottom: 8px; padding: 5px; border-left: 3px solid #28a745;">
                                <span style="font-weight: bold; color: #325e68;">${campo.nombre}:</span> 
                                <span style="color: #28a745; font-weight: bold;">✓ Sí</span>
                            </div>`;
                    }
                } else {
                    if (campo.valor && campo.valor.trim() !== '') {
                        resultado += `
                            <div style="margin-bottom: 8px; padding: 5px; border-left: 3px solid #325e68;">
                                <div style="font-weight: bold; color: #325e68; margin-bottom: 3px;">${campo.nombre}:</div>
                                <div style="color: #333; line-height: 1.4;">${campo.valor}</div>
                            </div>`;
                    }
                }
            });
        }
        return resultado;
    };

    // 🆕 Función helper para renderizar contenido personalizado para PDF (usado en evoluciones; compacto alineado con ModalEvolucion)
    const renderizarContenidoPersonalizadoParaPDF = (contenidoPersonalizado, opciones = {}) => {
        const compacto = opciones.compacto === true;
        if (!contenidoPersonalizado) {
            return "";
        }

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return "";
        }

        let resultado = "";

        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                if (campo.tipo === 'checkbox') {
                    if (campo.check) {
                        resultado += compacto
                            ? `<div style="margin-top: 4px; font-size: 10px; line-height: 1.35;"><strong style="font-size: 10px">${campo.nombre}:</strong> Sí</div>`
                            : `<strong>${campo.nombre}:</strong> Sí<br />`;
                    }
                } else if (campo.valor && campo.valor.trim() !== '') {
                    resultado += compacto
                        ? `<div style="margin-top: 4px; font-size: 10px; line-height: 1.35;"><strong style="font-size: 10px">${campo.nombre}:</strong> ${campo.valor}</div>`
                        : `<br /><label><strong>${campo.nombre}:</strong></label><br />${campo.valor}<br />`;
                }
            });
        }

        return resultado;
    };

    // 🆕 Función helper para renderizar historia clínica JSON con bandas grises
    const renderizarHistoriaClinicaJsonPDF = (historia) => {
        const nombreCompleto = `${primerNombre || ''} ${segundoNombre || ''} ${primerApellido || ''} ${segundoApellido || ''}`.trim();
        const documentoCompleto = `${tipoDocumento || ''} - ${numeroDocumento || ''}`;

        // Banner + Tabla de info del paciente agrupados para evitar separación
        let bannerYTablaInfoPaciente = `
            <div class="no-page-break" style="page-break-inside: avoid !important; margin-bottom: 15px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; text-align: center; border: 1px solid #dee2e6; margin-bottom: 8px;">
                    HISTORIA CLÍNICA
                </div>
                <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 25%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${new Date(historia.fecha).toLocaleString()}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                            <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${historia.profesional || ''}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Datos de la historia (secciones con tablas)
        let tablaDatos = '';
        try {
            const datos = typeof historia.datos === 'string' ? JSON.parse(historia.datos) : historia.datos;
            const estructura = typeof historia.plantilla_estructura === 'string' 
                ? JSON.parse(historia.plantilla_estructura) 
                : historia.plantilla_estructura;

            if (estructura && estructura.secciones && Array.isArray(estructura.secciones)) {
                estructura.secciones.forEach(seccion => {
                    let seccionTieneContenido = false;
                    let filasSeccion = '';

                    if (seccion.campos && Array.isArray(seccion.campos)) {
                        seccion.campos.forEach(campo => {
                            const valor = datos[campo.id];
                            if (valor !== undefined && valor !== null && valor !== '') {
                                seccionTieneContenido = true;

                                // Formatear valor según tipo de campo
                                let valorFormateado = valor;
                                if (campo.tipo === 'checkbox') {
                                    valorFormateado = valor ? 'Sí' : 'No';
                                } else if (campo.tipo === 'textarea') {
                                    valorFormateado = valor.replace(/\n/g, '<br>');
                                }

                                filasSeccion += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 6px 10px; width: 30%; border: 1px solid #dee2e6;">${campo.label}</td>
                                        <td style="background-color: #ffffff; padding: 6px 10px; border: 1px solid #dee2e6;">${valorFormateado}</td>
                                    </tr>`;
                            }
                        });
                    }

                    // Solo mostrar sección si tiene contenido
                    if (seccionTieneContenido) {
                        tablaDatos += `
                            <div class="no-page-break" style="margin-bottom: 15px; page-break-inside: avoid !important;">
                                <table class="no-page-break" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #dee2e6; page-break-inside: avoid !important;">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; border: 1px solid #dee2e6;">${seccion.titulo}</td>
                                        </tr>
                                        ${filasSeccion}
                                    </tbody>
                                </table>
                            </div>`;
                    }
                });
            }
        } catch (error) {
            console.error('Error parseando datos de historia JSON:', error);
            tablaDatos = `<div style="color: red; padding: 8px;">Error al cargar datos de la historia</div>`;
        }

        const firmaSrcRender = (historia.firma_final || historia.firma) || '';
        let bloqueFirmaProfesional = '';
        if (historia.profesional && firmaSrcRender) {
            const pieFirmaHtml = historia.texto_pie_firma_usuario
                ? `<div style="font-size: 10px; color: #6c757d; white-space: pre-line;">${historia.texto_pie_firma_usuario}</div>`
                : `<div style="font-size: 10px; color: #6c757d;">
                    ${historia.profesional}<br/>
                    <strong>RM:</strong> ${historia.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${historia.codigo_habilitacion || 'N/A'}
                  </div>`;
            bloqueFirmaProfesional = `
                <div class="no-page-break" style="margin-top: 10px; page-break-inside: avoid !important;">
                    <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 11px; text-align: left; margin-bottom: 5px;">
                        FIRMA DEL PROFESIONAL
                    </div>
                    <table style="border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 5px 20px 5px 10px; vertical-align: middle;">
                                    ${pieFirmaHtml}
                                </td>
                                <td style="padding: 5px 10px; vertical-align: middle;">
                                    <img src="${firmaSrcRender}" alt="Firma" style="max-width: 170px; max-height: 80px; display: block;" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        return `
            <div class="no-page-break" style="margin-bottom: 20px; page-break-inside: avoid !important;">
                ${bannerYTablaInfoPaciente}
                ${tablaDatos}
                ${bloqueFirmaProfesional}
            </div>`;
    };

    // 🆕 Función para generar encabezado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) return '';

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    return (

        <div className="hold-transition">
            <Header />
            <Aside
                activelink="patients"
                atencionPaciente={true}
                abrirEvolucion={abrirEvolucion}
                // COMENTADO: Sistema antiguo de historia clínica - Ya no se usa
                // abrirHistoriaClinica={abrirHistoriaClinica}
                abrirHistoriaClinicaJson={abrirHistoriaClinicaJson}
                abrirExamenes={abrirExamenes}
                abrirArchivosClinicos={abrirArchivosClinicos}
                abrirFormulas={abrirFormulas}
                abrirOtrosDocumentos={abrirOtrosDocumentos}
                abrirIncapacidades={abrirIncapacidades}
                abrirRecomendaciones={abrirRecomendaciones}
                abrirRemisiones={abrirRemisiones}
                abrirContraremisiones={abrirContraremisiones}
                abrirConsentimientos={abrirConsentimientos}
                abrirRipsFev={abrirRipsFev}
                abrirRipsSinFev={abrirRipsSinFev}
                abrirRipsConvenio={abrirRipsConvenio}
                abrirOdontograma={abrirOdontograma}
                abrirToxina={abrirToxina}
                esFacturador={esFacturador}
                tienePermisoDocumentos={tienePermisoDocumentos}
                tienePermisoRips={tienePermisoRips}
                tienePermisoOdontograma={tienePermisoOdontograma}
                tienePermisoToxina={tienePermisoToxina}
                tienePermisoEvolucion={tienePermisoEvolucion}
                tienePermisoHistoriaClinica={tienePermisoHistoriaClinica}
            />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc3"><Link to="/pacientes">Listado de Pacientes</Link></li>
                                    <li className="breadcrumb-item" key="bc4">Atender Paciente</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0 d-flex flex-wrap align-items-center">
                                    <span>Atención del Paciente</span>
                                    {fechaIngreso && (
                                        <span className="badge badge-paciente-ingreso ml-2 mt-1 mt-sm-0">
                                            Fecha de Ingreso: {formatearFechaHoraIngreso(fechaIngreso)}
                                        </span>
                                    )}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">

                        {/* Botones de acceso rápido - Alineados a la derecha */}
                        <div className="row mb-3">
                            <div className="col-md-12 text-right">
                                <div className="btn-group" role="group">
                                    {(tienePermisoEvolucion || tienePermisoHistoriaClinica) && (
                                    <div className="dropdown" style={{ display: 'inline-block', position: 'relative' }}>
                                        <button 
                                            className="btn btn-primary" 
                                            type="button" 
                                            onClick={() => setShowDropdownHistoriaClinica(!showDropdownHistoriaClinica)}
                                            style={{ marginRight: '10px', borderRadius: '4px' }}
                                        >
                                            <i className="fas fa-user-md"></i>&nbsp; Atención del Paciente <i className="fas fa-caret-down"></i>
                                        </button>
                                        {showDropdownHistoriaClinica && (
                                            <div 
                                                className="dropdown-menu show" 
                                                style={{ 
                                                    display: 'block', 
                                                    position: 'absolute', 
                                                    top: '100%', 
                                                    left: 0,
                                                    zIndex: 1000,
                                                    minWidth: '200px'
                                                }}
                                            >
                                                {tienePermisoEvolucion && (
                                                <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        abrirEvolucion();
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-notes-medical"></i>&nbsp; Evolución
                                                </button>
                                                )}
                                                {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
                                                {/* <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        abrirHistoriaClinica();
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-file-medical"></i>&nbsp; Historia Clínica (Antigua)
                                                </button> */}
                                                {tienePermisoHistoriaClinica && (
                                                <button 
                                                    className="dropdown-item" 
                                                    onClick={() => { 
                                                        history.push(`/historia-clinica-json?id=${pacienteId}`);
                                                        setShowDropdownHistoriaClinica(false);
                                                    }}
                                                >
                                                    <i className="fas fa-file-medical"></i>&nbsp; Historia Clínica
                                                </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    )}
                                    <Link 
                                        to={`/estado-cuenta-paciente?id=${pacienteId}`}
                                        className="btn btn-secondary"
                                        style={{ borderRadius: '4px' }}
                                    >
                                        <i className="fas fa-dollar-sign"></i>&nbsp; Cartera 
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row" id="panel-info-general">
                                            <div className="paciente-img">
                                                <div className="paciente-profile-img-container">
                                                    <img 
                                                        src={perfilimg} 
                                                        className="profile-img" 
                                                        alt="Foto del paciente"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/dist/img/user-default.jpg';
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="paciente-meta" style={{ paddingLeft: '15px' }}>
                                                <div className="row">
                                                    {/* Columna 1 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-user"></i>
                                                        <span className="micro-label">Nombres y Apellidos</span>
                                                        <span className="patient-meta-read-only">{primerNombre} {segundoNombre} {primerApellido} {segundoApellido}</span>
                                                    </div>

                                                    {/* Columna 2 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-id-card"></i>
                                                        <span className="micro-label">Tipo Documento - Documento</span>
                                                        <span className="patient-meta-read-only">{tipoDocumento} - {numeroDocumento}</span>
                                                    </div>

                                                    {/* Columna 3 */}
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-envelope"></i>
                                                        <span className="micro-label">e-mail</span>
                                                        <span className="patient-meta-read-only">{email}</span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-calendar-alt"></i>
                                                        <span className="micro-label">Fecha de Nacimiento</span>
                                                        <span className="patient-meta-read-only">{formatearFechaNacimientoLegible(fechaNacimiento)}</span>
                                                    </div>

                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-birthday-cake"></i>
                                                        <span className="micro-label">Edad</span>
                                                        <span className="patient-meta-read-only">{edad || 'No registrada'}</span>
                                                    </div>

                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-venus"></i>
                                                        <span className="micro-label">Sexo</span>
                                                        <span className="patient-meta-read-only">{sexoBiologico[genero] || 'No registrado'}</span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-tint"></i>
                                                        <span className="micro-label">Tipo de Sangre</span>
                                                        <span className="patient-meta-read-only">{tipoSangre?.toUpperCase() || 'No registrado'}</span>
                                                    </div>

                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-pray"></i>
                                                        <span className="micro-label">Religión</span>
                                                        <span className="patient-meta-read-only">{religion || 'No registrada'}</span>
                                                    </div>

                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <span className="micro-label">Celular</span>
                                                        <span className="patient-meta-read-only">{celular || 'No registrado'}</span>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-wheelchair"></i>
                                                        <span className="micro-label">Discapacidad</span>
                                                        <span className="patient-meta-read-only">{discapacidades[discapacidad]}</span>
                                                    </div>

                                                    <div className="col-md-4 dato-paciente">
                                                        <i className="fas fa-bullhorn"></i>
                                                        <span className="micro-label">Clasificación de Riesgo</span>
                                                        <span className="patient-meta-read-only">{clasificacionRiesgo?.toUpperCase() || ''}</span>
                                                    </div>

                                                    {profesionalAsignado && (
                                                        <div className="col-md-4 dato-paciente">
                                                            <i className="fas fa-user-md"></i>
                                                            <span className="micro-label">Profesional Asignado</span>
                                                            <span className="patient-meta-read-only">{profesionalAsignado}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card" id="panel-info-paciente">
                                    <div className="card-header" style={{ backgroundColor: '#fff' }}>
                                        <h4 className="card-title w-100">
                                            <button
                                                type="button"
                                                className="btn btn-link d-block w-100 text-left p-0"
                                                onClick={() => setAcordeonInfoPaciente(!acordeonInfoPaciente)}
                                                aria-expanded={acordeonInfoPaciente}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    position: 'relative',
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                Información del Paciente
                                            </button>
                                        </h4>
                                    </div>
                                    <div className={`collapse ${acordeonInfoPaciente ? 'show' : ''}`} style={{ padding: '10px 20px' }}>
                                        <fieldset>
                                            <legend>Domicilio:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telefono">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefono}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="direccionPaciente">Dirección</label>
                                                        <span className="patient-meta-read-only">{direccion}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudad">Ciudad</label>
                                                        <span className="patient-meta-read-only">{ciudad} </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="paisResidencia">País</label>
                                                        <span className="patient-meta-read-only">{paisResidencia}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Datos Adicionales:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Vinculación</label>
                                                        <span className="patient-meta-read-only">{vinculacion.toUpperCase()}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>EPS / Aseguradora</label>
                                                        <span className="patient-meta-read-only">{nombreEps}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Clasificación de Riesgo</label>
                                                        <span className="patient-meta-read-only">{clasificacionRiesgo.toUpperCase()}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Convenio / Poliza</label>
                                                        <span className="patient-meta-read-only">{convenio}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Cómo se Enteró</label>
                                                        <span className="patient-meta-read-only">{medioPublicitario}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Referido Por</label>
                                                        <span className="patient-meta-read-only">{referido}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Etnia</label>
                                                        <span className="patient-meta-read-only">{etnias[etnia]}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Identidad de Género</label>
                                                        <span className="patient-meta-read-only">{identidadesGenero[identidadGenero]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Acompañante:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Nombre</label>
                                                        <span className="patient-meta-read-only">{nombreAcompanante}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoAcompanante}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Parentesco</label>
                                                        <span className="patient-meta-read-only">{parentescoAcompanante}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Documento</label>
                                                        <span className="patient-meta-read-only">{documentoAcompanante}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>e-mail</label>
                                                        <span className="patient-meta-read-only">{emailAcompanante}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset>
                                            <legend>Responsable:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Nombre</label>
                                                        <span className="patient-meta-read-only">{nombreResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Parentesco</label>
                                                        <span className="patient-meta-read-only">{parentescoResponsable}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>Documento</label>
                                                        <span className="patient-meta-read-only">{docResponsable}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>e-mail</label>
                                                        <span className="patient-meta-read-only">{emailResponsable}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset style={estiloInfoMenores}>
                                            <legend>Información Adicional Para Menores de Edad:</legend>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="nombreMadre">Nombre de la Madre</label>
                                                        <span className="patient-meta-read-only">{nombreMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="docMadre">Número de Documento</label>
                                                        <span className="patient-meta-read-only">{documentoMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telMadre">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoMadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ocupacionMadre">Ocupación</label>
                                                        <span className="patient-meta-read-only">{ocupacionMadre}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="nombrePadre">Nombre del Padre</label>
                                                        <span className="patient-meta-read-only">{nombrePadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="docPadre">Número de Documento</label>
                                                        <span className="patient-meta-read-only">{documentoPadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telPadre">Teléfono</label>
                                                        <span className="patient-meta-read-only">{telefonoPadre}</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="ocupacionPadre">Ocupación</label>
                                                        <span className="patient-meta-read-only">{ocupacionPadre}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="card ap2-atencion-consulta">
                                    <div className="card-header" style={{ backgroundColor: '#fff' }}>
                                        <h4 className="card-title w-100">
                                            <button
                                                type="button"
                                                className="btn btn-link d-block w-100 text-left p-0"
                                                onClick={() => setAcordeonAtencion(!acordeonAtencion)}
                                                aria-expanded={acordeonAtencion}
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                    position: 'relative',
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                Atención de la Consulta
                                            </button>
                                        </h4>
                                    </div>
                                    <div className={`collapse ${acordeonAtencion ? 'show' : ''}`}>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* GRUPO 1: Historia Clínica Principal (controlado por permisos) */}
                                                {(tienePermisoEvolucion || tienePermisoHistoriaClinica) && (
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-ap2-tool dropdown-toggle" 
                                                            onClick={() => setShowDropdownHistoriaClinicaConsulta(!showDropdownHistoriaClinicaConsulta)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownHistoriaClinicaConsulta}
                                                        >
                                                            <i className="fas fa-notes-medical mr-2"></i>
                                                            Historia Clínica
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownHistoriaClinicaConsulta ? 'show' : ''}`}>
                                                            {tienePermisoEvolucion && (
                                                            <button className="dropdown-item" onClick={() => { abrirEvolucion(true); setShowDropdownHistoriaClinicaConsulta(false); }}>
                                                                <i className="fas fa-edit mr-2 text-info"></i>
                                                                Evolucionar Historia
                                                            </button>
                                                            )}
                                                            {tienePermisoHistoriaClinica && (
                                                            <button className="dropdown-item" onClick={() => { abrirHistoriaClinicaJson(); setShowDropdownHistoriaClinicaConsulta(false); }}>
                                                                <i className="fas fa-file-medical mr-2 text-info"></i>
                                                                Historia Clínica
                                                            </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                )}

                                                {/* GRUPO 2: RIPS (controlado por permiso ripsPaciente) */}
                                                {tienePermisoRips && (
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-ap2-tool dropdown-toggle" 
                                                            onClick={() => setShowDropdownRips(!showDropdownRips)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownRips}
                                                        >
                                                            <i className="fas fa-file-invoice mr-2"></i>
                                                            RIPS
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownRips ? 'show' : ''}`}>
                                                            {esFacturador && (
                                                                <>
                                                                    <button className="dropdown-item" onClick={() => { abrirRipsFev(); setShowDropdownRips(false); }}>
                                                                        <i className="fas fa-check-circle mr-2 text-info"></i>
                                                                        Registro Rips FEV
                                                                    </button>
                                                                    <button className="dropdown-item" onClick={() => { abrirRipsConvenio(); setShowDropdownRips(false); }}>
                                                                        <i className="fas fa-handshake mr-2 text-info"></i>
                                                                        Rips Por Convenios
                                                                    </button>
                                                                </>
                                                            )}
                                                            {!esFacturador && (
                                                                <button className="dropdown-item" onClick={() => { abrirRipsSinFev(); setShowDropdownRips(false); }}>
                                                                    <i className="fas fa-file-alt mr-2 text-info"></i>
                                                                    Registro Rips Sin FEV
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                )}

                                                {/* GRUPO 3: Formularios y plantillas (controlado por permiso documentosPaciente) */}
                                                {tienePermisoDocumentos && (
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-ap2-tool dropdown-toggle" 
                                                            onClick={() => setShowDropdownDocumentos(!showDropdownDocumentos)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownDocumentos}
                                                        >
                                                            <i className="fas fa-file-medical mr-2"></i>
                                                            Documentos
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownDocumentos ? 'show' : ''}`}>
                                                            <button className="dropdown-item" onClick={() => { abrirExamenes(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-microscope mr-2 text-info"></i>
                                                                Ayudas Diagnósticas
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirArchivosClinicos(); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-images mr-2 text-info"></i>
                                                                Imágenes y archivos
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirConsentimientos(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-file-signature mr-2 text-info"></i>
                                                                Consentimientos
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirContraremisiones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-reply mr-2 text-info"></i>
                                                                Contraremisiones
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirFormulas(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-prescription mr-2 text-info"></i>
                                                                Fórmulas Médicas
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirOtrosDocumentos(); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-file-alt mr-2 text-info"></i>
                                                                Otros Documentos
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirIncapacidades(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-bed mr-2 text-info"></i>
                                                                Incapacidades
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirRecomendaciones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-clipboard-list mr-2 text-info"></i>
                                                                Recomendaciones
                                                            </button>
                                                            <button className="dropdown-item" onClick={() => { abrirRemisiones(true); setShowDropdownDocumentos(false); }}>
                                                                <i className="fas fa-share mr-2 text-info"></i>
                                                                Remisiones
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                )}

                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-ap2-tool w-100"
                                                        onClick={abrirArchivosClinicos}
                                                    >
                                                        <i className="fas fa-images mr-2"></i>
                                                       Ayudas Diagnósticas
                                                    </button>
                                                </div>

                                                {/* GRUPO 4: Gráficos (controlado por permisos odontogramaPaciente y toxinaPaciente) */}
                                                {(tienePermisoOdontograma || tienePermisoToxina) && (
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <div className="btn-group w-100" role="group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-ap2-tool dropdown-toggle" 
                                                            onClick={() => setShowDropdownGraficos(!showDropdownGraficos)}
                                                            aria-haspopup="true" 
                                                            aria-expanded={showDropdownGraficos}
                                                        >
                                                            <i className="fas fa-chart-line mr-2"></i>
                                                            Gráficos
                                                        </button>
                                                        <div className={`dropdown-menu w-100 ${showDropdownGraficos ? 'show' : ''}`}>
                                                            {tienePermisoOdontograma && (
                                                            <button className="dropdown-item" onClick={() => { abrirOdontograma(); setShowDropdownGraficos(false); }}>
                                                                <i className="fas fa-tooth mr-2 text-info"></i>
                                                                Odontograma
                                                            </button>
                                                            )}
                                                            {tienePermisoToxina && (
                                                            <button className="dropdown-item" onClick={() => { abrirToxina(); setShowDropdownGraficos(false); }}>
                                                                <i className="fas fa-syringe mr-2 text-info"></i>
                                                                Toxina Botulínica
                                                            </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                )}

                                                {/* GRUPO 5: Imprimir historia (médico con permiso clínico o administrativo) */}
                                                {(tienePermisoEvolucion || tienePermisoHistoriaClinica || esAdministrativo) && (
                                                <div className="col-md-6 col-lg-4 mb-3">
                                                    <button 
                                                        type="button"
                                                        className="btn btn-ap2-tool-print w-100" 
                                                        onClick={abrirModalImpresionHistoria}
                                                    >
                                                        <i className="fas fa-print mr-2"></i>
                                                        Imprimir Historia
                                                    </button>
                                                </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {
                            idCita ? seccionEstadosCita(idCita) : null
                        }


                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} message={toastMsg} />

            <ModalOdontograma
                show={showOdontograma}
                onHide={cerrarOdontograma}
                pacienteId={paciente_id}
                paciente={{
                    primerNombre,
                    segundoNombre,
                    primerApellido,
                    segundoApellido,
                    tipoDocumento,
                    numeroDocumento
                }}
            />

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Clasificación de Riesgo {clasificacionRiesgo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{descripcionClasificacion}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* COMENTADO: Sistema antiguo de historia clínica - Ya no se usa */}
            {/* <Modal show={showHistoriaClinica} onHide={cerrarHistoriaClinica} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{tituloHistoriaClinica}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalHistoriaClinica cargarHistorial={cargarHistorialHistoriaClinica} cerrarModal={cerrarHistoriaClinica} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal> */}

            {/* Historia Clínica JSON ahora es una página completa en /historia-clinica-json */}

            <DocumentoPacienteModal show={showExamenes} onHide={cerrarExamenes} title="Ayudas Diagnósticas">
                <ModalExamenes cargarHistorial={cargarHistorialExamenes} cerrarModal={cerrarExamenes} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>

            <ModalArchivosClinicos
                show={showArchivosClinicos}
                onHide={cerrarArchivosClinicos}
                guardarCambios={guardarCambios}
            />


            <DocumentoPacienteModal show={showFormulas} onHide={cerrarFormulas} title="Fórmulas Médicas">
                <ModalFormulas cargarHistorial={cargarHistorialFormulas} cerrarModal={cerrarFormulas} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showOtrosDocumentos} onHide={cerrarOtrosDocumentos} title="Otros Documentos">
                <ModalOtrosDocumentos cargarHistorial={cargarHistorialOtrosDocumentos} cerrarModal={cerrarOtrosDocumentos} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>

            <DocumentoPacienteModal show={showIncapacidades} onHide={cerrarIncapacidades} title="Incapacidades">
                <ModalIncapacidades cargarHistorial={cargarHistorialIncapacidades} cerrarModal={cerrarIncapacidades} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>


            <DocumentoPacienteModal show={showRecomendaciones} onHide={cerrarRecomendaciones} title="Recomendaciones">
                <ModalRecomendaciones cargarHistorial={cargarHistorialRecomendaciones} cerrarModal={cerrarRecomendaciones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>


            <DocumentoPacienteModal show={showRemisiones} onHide={cerrarRemisiones} title="Remisiones">
                <ModalRemisiones cargarHistorial={cargarHistorialRemisiones} cerrarModal={cerrarRemisiones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>


            <DocumentoPacienteModal show={showContraremisiones} onHide={cerrarContraremisiones} title="Contraremisiones">
                <ModalContraremisiones cargarHistorial={cargarHistorialContraremisiones} cerrarModal={cerrarContraremisiones} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} docPaciente={numeroDocumento} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>


            <DocumentoPacienteModal show={showConsentimientos} onHide={cerrarConsentimientos} title="Consentimientos Informados">
                <ModalConsentimientos cargarHistorial={cargarHistorialConsentimientos} cerrarModal={cerrarConsentimientos} guardarCambios={guardarCambios} anamnesis={getInfoAnamnesisPDF} paciente={{ primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
            </DocumentoPacienteModal>


            <Modal show={showRipsSinFev} onHide={cerrarRipsSinFev} size="xl" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS Sin FEV</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RegistroRipsSinFev cargarHistorial={cargarHistorialRipsSinFev} cerrarModal={cerrarRipsSinFev} guardarCambios={guardarCambios} paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>

            <Modal show={showRipsFev} onHide={cerrarRipsFev} size="xl" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS FEV</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RegistroRipsFev
                        paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }}
                        onClose={cerrarRipsFev}
                    />
                </Modal.Body>
            </Modal>

            <Modal show={showRipsConvenio} onHide={cerrarRipsConvenio} size="xl" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Registro RIPS Por Convenio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <RegistroRipsConvenio cargarHistorial={cargarHistorialRipsConvenio} cerrarModal={cerrarRipsConvenio} guardarCambios={guardarCambios} paciente={{ id: pacienteId, primerNombre: primerNombre, segundoNombre: segundoNombre, primerApellido: primerApellido, segundoApellido: segundoApellido, numeroDocumento: numeroDocumento, tipoDocumento: tipoDocumento }} />
                </Modal.Body>
            </Modal>

            {/* Modal filtros impresión historia consolidada */}
            <Modal show={showModalFiltrosImpresion} onHide={() => setShowModalFiltrosImpresion(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Imprimir historia consolidada</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className="custom-control custom-checkbox mb-3">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="filtroImpresionTodos"
                                checked={filtroImpresionTodos}
                                onChange={(e) => setFiltroImpresionTodos(e.target.checked)}
                            />
                            <label className="custom-control-label" htmlFor="filtroImpresionTodos">
                                Incluir todos los registros (sin filtrar por profesional ni fechas)
                            </label>
                        </div>
                    </div>
                    {!filtroImpresionTodos && (
                        <>
                            <div className="form-group">
                                <label htmlFor="filtroImpresionUsuario">Profesional</label>
                                <select
                                    id="filtroImpresionUsuario"
                                    className="form-control"
                                    value={filtroImpresionUsuario}
                                    onChange={(e) => setFiltroImpresionUsuario(e.target.value)}
                                >
                                    <option value="">Todos los profesionales</option>
                                    {profesionalesImpresion.map((prof) => (
                                        <option key={prof.id ?? prof.user_id} value={prof.id ?? prof.user_id}>
                                            {`${prof.name || prof.user_name || ''} ${prof.lastname || prof.user_lastname || ''}`.trim() || `Usuario ${prof.id ?? prof.user_id}`}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="filtroImpresionFechaInicio">Fecha inicio</label>
                                        <input
                                            type="date"
                                            id="filtroImpresionFechaInicio"
                                            className="form-control"
                                            value={filtroImpresionFechaInicio}
                                            onChange={(e) => setFiltroImpresionFechaInicio(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="filtroImpresionFechaFin">Fecha fin</label>
                                        <input
                                            type="date"
                                            id="filtroImpresionFechaFin"
                                            className="form-control"
                                            value={filtroImpresionFechaFin}
                                            onChange={(e) => setFiltroImpresionFechaFin(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalFiltrosImpresion(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={confirmarImpresionHistoria}>
                        <i className="fas fa-print mr-1"></i>
                        Generar PDF
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* 🆕 Modal de carga mientras se genera el PDF */}
            <Modal show={showModalGenerandoPDF} backdrop="static" keyboard={false} centered>
                <Modal.Body className="text-center py-4">
                    <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <h5 className="mb-2">Generando historia consolidada...</h5>
                    <p className="text-muted mb-0">Por favor espere, esto puede tomar unos momentos</p>
                </Modal.Body>
            </Modal>

            <ToastContainer className="toast-exito" position="bottom-center">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={4500} autohide>
                    <Toast.Body className="d-flex align-items-center">
                        <i className="fas fa-check-circle text-success mr-2" style={{ fontSize: '1.35rem', flexShrink: 0 }} aria-hidden="true" />
                        <span>{toastMsg}</span>
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            <style>{`
                .btn-link::after,
                .btn-link[aria-expanded="true"]::after,
                .btn-link[aria-expanded="false"]::after {
                    display: none !important;
                }
                .card-header .btn-link {
                    position: relative;
                    background-color: transparent;
                    border: none;
                    color: #495057;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }
                .card-header .btn-link:hover {
                    color: #28a745;
                    text-decoration: none;
                    background-color: rgba(40, 167, 69, 0.1);
                }
                .card-header .btn-link[aria-expanded="true"] {
                    color: #28a745;
                    background-color: rgba(40, 167, 69, 0.1);
                }
                .card-header .btn-link::after {
                    display: none !important;
                }
                .card-header {
                    border-bottom: 1px solid #dee2e6;
                    background-color: #f8f9fa;
                }
                /* Atención de la consulta: botones tipo outline suave (evita aspecto de menú oscuro) */
                .ap2-atencion-consulta .btn-ap2-tool {
                    font-size: 14px;
                    font-weight: 600;
                    padding: 12px 16px;
                    border-radius: 10px;
                    background: #fff;
                    border: 1px solid rgba(23, 162, 184, 0.42);
                    color: #0a6b7d;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
                    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
                }
                .ap2-atencion-consulta .btn-ap2-tool:hover,
                .ap2-atencion-consulta .btn-ap2-tool:focus {
                    background: rgba(23, 162, 184, 0.1);
                    border-color: #17a2b8;
                    color: #05505f;
                }
                .ap2-atencion-consulta .btn-ap2-tool-print {
                    font-size: 14px;
                    font-weight: 600;
                    padding: 12px 16px;
                    border-radius: 10px;
                    background: #fff;
                    border: 2px solid #ffc107;
                    color: #856404;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
                    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
                }
                .ap2-atencion-consulta .btn-ap2-tool-print:hover,
                .ap2-atencion-consulta .btn-ap2-tool-print:focus {
                    background: rgba(255, 193, 7, 0.15);
                    border-color: #e0a800;
                    color: #533f03;
                }
                .ap2-atencion-consulta .dropdown-menu {
                    border-radius: 10px;
                    border: 1px solid rgba(0, 0, 0, 0.08);
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
                }
            `}</style>

        </div>
    );
}
export default AtenderPaciente2;